import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import map from 'lodash-es/map'

import { isLastListItem } from '../../../../utils/common'
import { Divider } from '../../../Divider'
import { Widget, WidgetContentItemsList } from '../../../Widget'
import { useEmailCopyTo, useEmailProfileContext } from '../../Email.hooks'
import { EmailProfileWidgetCopiedToContentSkeleton } from '../EmailProfileWidgetCopiedToContentSkeleton'

import {
  getEntityListProps,
  isItemsEmpty,
} from './EmailProfileWidgetCopiedTo.utils'

import * as styles from './EmailProfileWidgetCopiedTo.module.css'

function EmailProfileWidgetCopiedTo({
  initiallyExpanded,
  isSkeleton,
  items,
  widgetProps,
}) {
  const { t } = useTranslation()

  const { handleCloseModal, setModal } = useEmailProfileContext()

  const { handleClickDeleteCopiedEntity, handleDeleteCopiedEntity } =
    useEmailCopyTo({ onCloseModal: handleCloseModal, onSetModal: setModal })

  function renderList() {
    const itemsEntries = Object.entries(items).filter(
      ([, value]) => value.length > 0
    )

    return map(itemsEntries, ([key, value], index) => (
      <Fragment key={index}>
        <WidgetContentItemsList
          {...getEntityListProps({
            handleClickRemove: handleClickDeleteCopiedEntity,
            handleSubmitRemove: handleDeleteCopiedEntity,
            items: value,
            name: key,
            t,
          })}
          items={value}
        />
        {isLastListItem(itemsEntries.length, index) ? null : (
          <Divider className={styles.divider} />
        )}
      </Fragment>
    ))
  }

  return isItemsEmpty(items) ? null : (
    <Widget
      {...widgetProps}
      contentContainerProps={{
        Skeleton: EmailProfileWidgetCopiedToContentSkeleton,
      }}
      headerProps={{
        contentProps: {
          actionsProps: {
            EditButton: null,
          },
        },
      }}
      initiallyExpanded={initiallyExpanded}
      isSkeleton={isSkeleton}
      title={t('EmailProfile.CopiedToWidgetTitleKey')}
    >
      {items ? renderList() : null}
    </Widget>
  )
}

export default EmailProfileWidgetCopiedTo
